import * as React from 'react';

import { DocumentTitle } from '../../shared/DocumentTitle';
import { LocalRoutes } from '../../../utilities/LocalRoutes';
import { SideNavMenuItem } from './SideNavMenuItem';
import { TutorialDetails } from '../../../utilities/Constants';

export interface ITutorialsLayoutProps {
    children: React.ReactNode;
}

export function TutorialsLayout(props: ITutorialsLayoutProps) {
    return (
        <>
            <DocumentTitle title="Tutorials" />
            <div className="app-container tutorials">
                <header className="top-nav print-hide-display">
                    <div className="logo-container">
                        <img
                            className="logo-img rounded p-2"
                            src="/images/CheckmateGreenLogo.svg"
                            alt="Checkmate Logo"
                        />
                    </div>
                    <div className="nav-menu-item-container"></div>
                </header>
                <div className="app-body">
                    <aside className="left-nav print-hide-display">
                        <div>
                            <span>TUTORIALS</span>
                        </div>
                        <div className="pt-2 tutorial-links">
                            {TutorialDetails.map((details) => (
                                <SideNavMenuItem
                                    key={details.fileName}
                                    label={details.displayName}
                                    url={`${LocalRoutes.Tutorials}${
                                        LocalRoutes.ViewPDF
                                    }/${details.id.toString()}`}
                                    icon={details.icon}
                                />
                            ))}
                        </div>
                    </aside>
                    <main className="main-content px-4 pt-4">{props.children}</main>
                </div>
            </div>
        </>
    );
}
